import React from "react";
import { ArtworkReference, ArtworkReferenceType } from "../../models/ArtworkReference";
import ArtworkReferenceForm from "./ArtworkReferenceForm";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Box } from '@mui/material';
import Edit from "@mui/icons-material/Edit";
interface Props {
    reference: ArtworkReference;
    editMode: boolean;
    isOpen: boolean;
    isViewOnly: boolean;
    onClose: () => void;
    onSave: (ref: ArtworkReference) => void;
    onDelete: (ref: ArtworkReference) => void;
    setEditMode: (editing: boolean) => void;
    onCancel: () => void;
}

const ArtworkReferencePanel: React.FC<Props> = ({
    reference,
    editMode,
    isOpen,
    isViewOnly,
    onClose,
    onSave,
    onDelete,
    setEditMode,
    onCancel
}) => {
    return (

        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{marginRight: { xs: 1, sm: 2, md: 3 } }}>
            <DialogTitle>{editMode ? (reference.artworkReferenceId ? "Edit " : "Add") :"" } {reference.type === "Literature" ? "Literature Entry" : "Exhibition Entry"}</DialogTitle>
                <Button onClick={onClose}>{editMode ? 'Cancel' : 'Close'}</Button>
            </Box>

                <hr></hr>
            <DialogContent>

                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                    {editMode ? (
                        <ArtworkReferenceForm
                            initialValue={reference}
                            onSave={onSave}
                                onCancel={onCancel}
                        />
                    ) : (
                        <div>
                            <div>
                                <div className="text-xs font-medium text-gray-500 mb-1">Details</div>
                                <div className="whitespace-pre-wrap">{reference.details}</div>
                            </div>

                            {reference.dateText && (
                                <div>
                                    <div className="text-xs font-medium text-gray-500 mb-1">Date</div>
                                    <div>{reference.dateText}</div>
                                </div>
                            )}

                            {reference.url && (
                                <div>
                                    <div className="text-xs font-medium text-gray-500 mb-1">URL</div>
                                    <a
                                        href={reference.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-blue-600 hover:underline break-all"
                                    >
                                        {reference.url}
                                    </a>
                                </div>
                            )}
                        </div>
                    )}
                </Grid>

        </Grid>

            </DialogContent>

            <DialogActions>
                
                {!editMode && !isViewOnly && (
                    <Button variant="contained" onClick={() => onDelete(reference)}>Delete</Button>
                )}
                {!editMode && !isViewOnly && (
                    <Button variant="contained" onClick={() => setEditMode(true)}>Edit</Button>
                )}
                
            </DialogActions>
        </Dialog>
    );
};

export default ArtworkReferencePanel;
